import { names, requestSuccessFailure } from 'utilities/constants';

const configConstants = {
    ...names('CONFIG_LOAD_STARTED', 'CONFIG_LOAD_ENDED'),
    ...requestSuccessFailure('APP_CONFIG'),
    ...requestSuccessFailure('DENY_REASONS')
};

export default configConstants;